import { render } from "./MenuTools.vue?vue&type=template&id=db8eca76"
import script from "./MenuTools.vue?vue&type=script&lang=js"
export * from "./MenuTools.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__